module.exports = __webpack_public_path__ + "static/media/Helicopter.4fefa3c3.mp3";